import {
  getPersistedPreferredLanguage,
  getPreferredLanguage,
  isSpanishLanguage,
} from "utilities/getPreferredLanguage";

const SPANISH_PATH_PREFIX = "/es/";

function toSpanishPreferenceCenterLink(link: string): string {
  const url = new URL(link);
  const pathname = url.pathname.replace(/\/+$/, "") || "/";

  if (pathname === "/es" || pathname.startsWith(SPANISH_PATH_PREFIX)) {
    return `${url.origin}${pathname}${url.search}${url.hash}`;
  }

  if (pathname.endsWith("/es")) {
    const englishPath = pathname.slice(0, -3);
    url.pathname = englishPath ? `/es${englishPath}` : "/es";
    return `${url.origin}${url.pathname}${url.search}${url.hash}`;
  }

  const pathWithoutLeadingSlash = pathname.replace(/^\//, "");
  url.pathname = pathWithoutLeadingSlash ? `/es/${pathWithoutLeadingSlash}` : "/es";

  return `${url.origin}${url.pathname}${url.search}${url.hash}`;
}

/**
 * Prefer sessionStorage (login/registration) over Redux — unauth toggle does not
 * dispatch setPreferredLanguage; PreferredLanguage uses the same order.
 */
export function getLocalizedPreferenceCenterLink(
  preferenceCenterLink: string,
  preferredLanguage?: string | null,
): string {
  const trimmedLink = preferenceCenterLink.trim();
  if (!trimmedLink) {
    return trimmedLink;
  }

  const resolvedLanguage = getPersistedPreferredLanguage() ?? preferredLanguage;
  const useSpanish = isSpanishLanguage(getPreferredLanguage(resolvedLanguage));

  if (!useSpanish) {
    return trimmedLink;
  }

  return toSpanishPreferenceCenterLink(trimmedLink);
}
